import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';

export default class UserPointsPage extends UserPage {
  oninit(vnode) {
    super.oninit(vnode);
    
    this.pointsHistory = [];
    this.loading = true;
    this.hasMore = false;
    this.loadingMore = false;
    
    // 加载用户
    this.loadUser(m.route.param('username'));
  }

  show(user) {
    super.show(user);
    
    // 用户加载完成后，加载积分历史
    if (this.user) {
      this.loadPointsHistory();
    }
  }

  loadPointsHistory(offset = 0) {
    if (!this.user) return;
    
    this.loading = offset === 0;
    this.loadingMore = offset > 0;
    
    return app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/users/' + this.user.id() + '/point-logs',
      params: {
        page: {
          offset,
          limit: 20
        }
      }
    }).then(response => {
      if (offset === 0) {
        this.pointsHistory = response.data || [];
      } else {
        this.pointsHistory = (this.pointsHistory || []).concat(response.data || []);
      }
      
      this.hasMore = !!response.links && !!response.links.next;
      this.loading = false;
      this.loadingMore = false;
      m.redraw();
    }).catch(error => {
      console.error('Error loading points history:', error);
      this.loading = false;
      this.loadingMore = false;
      this.pointsHistory = [];
      m.redraw();
    });
  }

  loadMore() {
    if (this.loadingMore || !this.hasMore) return;
    
    this.loadPointsHistory(this.pointsHistory.length);
  }

  content() {
    if (this.loading && this.pointsHistory.length === 0) {
      return (
        <div className="UserPointsPage">
          <LoadingIndicator />
        </div>
      );
    }

    return (
      <div className="UserPointsPage">
        {/* <div className="UserPointsPage-header">
          <h2>{app.translator.trans('tf-custom-profile.forum.points.title')}</h2>
          {this.user && (
            <p>{app.translator.trans('tf-custom-profile.forum.points.description')} - {this.user.displayName()}</p>
          )}
        </div> */}
        
        <div className="UserPointsPage-content">
          {this.pointsHistory && this.pointsHistory.length > 0 ? (
            <div className="PointsHistoryList">
              {this.pointsHistory.map((historyItem, index) => {
                // 格式化日期为 YYYY-MM-DD
                const formatDate = (dateString) => {
                  if (!dateString) return '';
                  const date = new Date(dateString);
                  const year = date.getFullYear();
                  const month = String(date.getMonth() + 1).padStart(2, '0');
                  const day = String(date.getDate()).padStart(2, '0');
                  return `${year}-${month}-${day}`;
                };
                
                return (
                  <div key={index} className="PointsHistoryList-item">
                    <div className="PointsHistoryList-item-date">
                      {historyItem.attributes && historyItem.attributes.createdAt 
                        ? formatDate(historyItem.attributes.createdAt)
                        : ''}
                    </div>
                    <div className="PointsHistoryList-item-reason">
                      {historyItem.attributes && historyItem.attributes.actionSubtype 
                        ? historyItem.attributes.actionSubtype
                        : '具体事由 (需要枚举)'}
                    </div>
                    <div className={`PointsHistoryList-item-points ${
                      historyItem.attributes && historyItem.attributes.pointsChange > 0 ? 'positive' : 'negative'
                    }`}>
                      {historyItem.attributes && historyItem.attributes.pointsChange
                        ? (historyItem.attributes.pointsChange > 0 ? '+' : '') + historyItem.attributes.pointsChange
                        : '0'}
                    </div>
                  </div>
                );
              })}
              
              {this.hasMore && (
                <div className="PointsHistoryList-loadMore">
                  <Button 
                    className="PointsHistoryList-loadMoreButton"
                    onclick={this.loadMore.bind(this)}
                    loading={this.loadingMore}
                  >
                    {app.translator.trans('tf-points.forum.points_history.load_more')}
                  </Button>
                </div>
              )}
            </div>
          ) : (
            <div className="PointsHistoryList-empty">
              <p>{app.translator.trans('tf-points.forum.points_history.empty')}</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

